// extracted by mini-css-extract-plugin
module.exports = {"title_div":"styles_title_div__2Bfg7","first_to_load":"styles_first_to_load__eoJ1u","carousel_img":"styles_carousel_img__3Iq1a"};